import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/notifications',
    });
  },
});
